module.exports = __webpack_public_path__ + "static/img/05chahua8.b413872.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/zcx/assets/images/05chahua8.png
// module id = r+22
// module chunks = 7